import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import uuid from 'uuid/v4';
import Toast from './index';

const toastContext = createContext();

export const ToastProvider = ({ children }) => {
  const [toastList, setToastList] = useState([]);
  const toastFromReducer = useSelector((state) => state.toast);
  const dispatch = useDispatch();

  useEffect(() => {
    if (toastFromReducer && toastList.every((item) => item.id !== toastFromReducer.id)) {
      setToastList((state) => [toastFromReducer, ...state]);
    }
  }, [toastFromReducer, toastList]);

  const displayToast = useCallback(({ message, icon }) => {
    setToastList((state) => [{ id: uuid(), open: true, message, icon }, ...state]);
  }, []);

  const hideToast = useCallback(
    (toast) => {
      setToastList((state) =>
        state.map((item) => (item.id === toast.id ? { ...toast, open: false } : toast))
      );
      dispatch({ type: 'HIDETOAST' });
    },
    [dispatch]
  );

  const removeToast = useCallback(
    (toast) => {
      setToastList((state) => state.filter((item) => item.id !== toast.id));
      dispatch({ type: 'HIDETOAST' });
    },
    [dispatch]
  );

  return (
    <toastContext.Provider value={{ toasts: toastList, displayToast, hideToast, removeToast }}>
      {children}
      <Toast />
    </toastContext.Provider>
  );
};

export const useToastContext = () => useContext(toastContext);
